import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();
export const getH5Cats = () => {
  return $get('/h5/h5Classify/list');
}

export const getH5HomeList = () => {
  return $get('/h5/h5Classify/home/list')
}

export const getPopup = adPage => {
  return $get(`/h5/popups/get/${adPage}`)
}

export default {
  getH5Cats,
  getH5HomeList,
  getPopup,
}
